module.exports = new __parcel__URL__("periscope-page.tpl.68f19192.svg").toString();